var Curriculog = Curriculog || {};

Curriculog.DropdownItemView = (function ($, _, Backbone, DropdownItemView) {

	DropdownItemView = Curriculog.CurriculogView.extend({
		template: 'Default/dropdownItem.html',

		initialize: function (options) {
			this.item =  options.item.toJSON();
			this.value = options.value || this.item.value;
			this.disabled = options.disabled || this.item.disabled ? ' disabled' : '';
			this.selectedValue = options.selectedValue === this.value;
			this.selected = options.selected || this.item.selected || this.selectedValue ? ' selected' : '';
			this.render();
		},

		render: function () {
			var templateVars = {
				item: this.item,
				value: this.value,
				disabled: this.disabled,
				selected: this.selected,
			};

			var el = nunjucks.render(this.template, templateVars);
			this.replaceElement(el);
		},

		setDisabled: function (val) {
			this.$el.attr('disabled', val);
		}
	});
	return DropdownItemView;

})($, _, Backbone, Curriculog.DropdownItemView || {});
